// Inline quick-add (CRO cards): require a variant selection before the Add to cart button is enabled.
(function () {
  function bind(form) {
    const select = form.querySelector('select[name="id"]');
    const submit = form.querySelector('.quick-add__submit');
    if (!select || !submit || submit.dataset.inlineBound) return;
    submit.dataset.inlineBound = '1';
    const sync = function () {
      submit.disabled = !select.value;
    };
    sync();
    select.addEventListener('change', sync);
  }

  function init(root) {
    (root || document).querySelectorAll('.quick-add__inline').forEach(bind);
  }

  if (document.readyState !== 'loading') {
    init(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  }
})();
